import { render, staticRenderFns } from "./verConsulta.vue?vue&type=template&id=6db78f6a&"
import script from "./verConsulta.js?vue&type=script&lang=js&"
export * from "./verConsulta.js?vue&type=script&lang=js&"
import style0 from "./verConsulta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports